/* eslint-disable no-unused-vars */
/* eslint-disable no-loop-func */
/* eslint-disable array-callback-return */
/* eslint-disable no-redeclare */

import React from "react";
import moment from "moment";
import ReactGA from "react-ga";
import momentz from "moment-timezone";
import axios from "axios";
import { firestore } from "../fire";
import { MenuItem } from "@material-ui/core";
import { formatDateFunc } from "../utils/dateFormatFunc";
import { is_weekend } from "../components/Modals/UOAModal/getDate";
import { BaseURL } from "../constants";

export const refreshDataAndExpirationsFunc = async (
  ticker,
  date = "",
  appState,
  setAppState
) => {
  setAppState({ errorMessages: [], refreshData: true });
  fetchQuoteInfoFunc(ticker, date, appState, setAppState);
  fetchHolderListFunc(ticker, setAppState);

  getExpirationOptionsFunc(ticker, date, appState, setAppState);

  if (appState.tickerChanged) setAppState({ confidence: 8, targetPrice: "" });

  ReactGA.event({
    category: "ChainAction",
    action: "Refreshed Data and Expirations",
    label: `${ticker}`,
  });
};

export const fetchQuoteInfoFunc = (
  ticker,
  date = "",
  appState,
  setAppState
) => {

  if (ticker === 'NULL' || ticker === null) return
  let endingTime = moment("9:30am", "h:mma");
  let startingTime = moment("12:00am", "h:mma");
  let nowTxt = momentz().tz("America/New_York").format("h:mma");
  let convertedText = moment(nowTxt, "h:mma");
  let americaDate = momentz
    .tz(new Date(), "America/New_York")
    .format("YYYY-MM-DD");
  let dateMade = date;
  let newDatetoMatch = moment(americaDate, "YYYY-MM-DD")
    .subtract(1, "days")
    .format("YYYY-MM-DD");
  if (
    moment(convertedText).isBefore(endingTime) &&
    moment(convertedText).isAfter(startingTime) &&
    moment(newDatetoMatch).isSame(date, "day")
  ) {
    dateMade = americaDate;
  }
  let apitoFetch;
  let newDate = momentz.tz(new Date(), "America/New_York").format("YYYY-MM-DD");
  let datetoSend = moment(dateMade).format("YYYYMMDD");

  apitoFetch = moment(dateMade).isSame(newDate, "day")
    ? `${BaseURL}/api/get-ticker-details/${ticker}`
    : `${BaseURL}/api/get-ticker-details/${ticker}?date=${datetoSend}`;
  if (ticker !== null) {
    setAppState({ refreshingQuote: true });
    axios
      .get(apitoFetch)
      .then((result) => {
        if (result && result.data) {
          let quoteInfo = Array.isArray(result.data)
            ? {
              // ...result.data[0],
              symbol: result.data[0].usymbol,
              change: result.data[0].spot_chg,
              changePercent: result.data[0].spot_chg_pct,
              latestPrice: result.data[0].spot,
            }
            : { ...result.data };

          setAppState({
            quoteInfo,
            refreshingQuote: false,
            errorMessages: [],
          });
        }
      })
      .catch((error) => {
        console.log(error);
        const err = "Unknown Symbol";
        setAppState({
          data: [],
          selections: {},
          quoteInfo: {},
          expirationOptions: [],
          expiration: "",
          calendarData: {},
          refreshingData: false,
          refreshingQuote: false,
          tickerChanged: false,
          shadingActive: true,
          callsAnswer: "",
          pullsAnswer: "",
          confidence: 8,
          targetPrice: 0,
          onPlay: false,
          skew: null,
          imp_vol: null,
          changeConfidenceDelay: false,
          educationInstance: null,
          dontChangeExpiration: false,
          sidepanelExpirations: [],
          modalDetail: [],
          modalDetail2: [],
          modalDetail3: [],
          OIDataCall: [],
          OIDataPut: [],
          OIDates: [],
          OIStrikes: [],
          OICallMax: 0,
          OIPutMax: 0,
          errorMessages: [...appState.errorMessages, err],
        });
      });
  }
};

export const fetchHolderListFunc = async (symbol, setAppState) => {
  try {
    const response = await axios.get(
      `${BaseURL}/api/getholderlist?symbol=${symbol}`
    );
    let lengthCheck =
      response.data.hieghestCalls.length || response.data.hieghestPuts.length;
    if (response && lengthCheck) {
      setAppState({
        holderList: {
          hieghestCalls: response.data.hieghestCalls,
          hieghestPuts: response.data.hieghestPuts,
        },
      });
    } else {
      setAppState({ holderList: [] });
    }
  } catch (error) {
    setAppState({ holderList: [] });
  }
};

export const getExpirationOptionsFunc = async (
  ticker,
  date,
  appState,
  setAppState
) => {
  if (!ticker || ticker.length < 1) {
    return;
  }
  var [docRef, expirationsList] = await Promise.all([firestore.collection("currentExpirations").doc(ticker),
  (await fetch(`${BaseURL}/api/expirations?ticker=${ticker}&date=${date}`)).json()]);

  await docRef
    .get()
    // .orderBy("key")
    .then((doc) => {
      if (doc.exists) {
        const expirationsObject = doc.data();
        let expirationOptions = [
          // Placeholder expiration date
          <MenuItem key="placeholder" value="placeholder">
            Expiration Date
          </MenuItem>,
        ];
        Object.keys(expirationsObject).map((item) => {
          const formattedDate = formatDateFunc(item);
          // Checks to make sure not including expirations in the past.  But includes expirations today.
          const startOfDay = momentz
            .tz(item, "America/New_York")
            .startOf("day");
          // Add one day so expiration doesn't disappear until day after it expires.
          const nextDay = moment(startOfDay + 1000 * 60 * 60 * 24).valueOf();

          const rightNow = momentz
            .tz(new Date(), "America/New_York")
            .startOf("day")
            .valueOf();

          if (nextDay <= rightNow) return; // Prevent old dates from being included in the expiration options
          expirationOptions.push(
            // Select option
            <MenuItem key={item} value={item}>
              {formattedDate}
            </MenuItem>
          );

          // saveExpirationOptions(expirationOptions);
          return null;
        });

        // Only fetch data at this point if ticker changed.
        let expiration = appState.dontChangeExpiration
          ? appState.expiration
          : findFirstExpirationFunc(expirationOptions);
        const validExpiration = expirationsList.some((item) => moment(item.expiry).isSame(moment(expiration).format('YYYY-MM-DD')))
        expiration = validExpiration ? expiration : expirationsList[0].expiry !== null ? moment(expirationsList[0].expiry).format('YYYY-MM-DD') : moment(expirationsList[1].expiry).format('YYYY-MM-DD')

        // if (appState.tickerChanged) {
        fetchDataFunc(ticker, expiration, date, appState, setAppState);
        // }

        setAppState({
          expiration,
          expirationOptions,
          tickerChanged: false,
          dontChangeExpiration: false,
        });
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    })
    .catch(function (error) {
      setAppState({
        weekendErrors:
          "Unable to get data at this moment. The Date might be a weekend or holiday. Check symbol or try again later. If the problem still persists, email support@optionsgeek.com.",
      });
      console.log("Error getting document:", error);
    });
  await firestore
    .collection("calendars")
    .doc(ticker)
    .get()
    .then((res) => {
      setAppState({
        calendarData: res.data() ? res.data() : {},
      });
    });
};

export const findFirstExpirationFunc = (list) => {
  const moments = list.map((li) => {
    return li.key !== "placeholder" && li.key.length === 10
      ? moment(li.key)
      : moment("2030-12-31");
  });
  const firstExpiration = moment.min(moments).format("YYYY-MM-DD");
  return firstExpiration;
};

export const fetchDataFunc = async (
  ticker,
  expiration,
  date,
  appState,
  setAppState
) => {
  fetchSkewFunc(ticker, date, appState, setAppState);
  fetchExpirationsFunc(ticker, date, appState, setAppState);
  fetchNewsFunc(ticker, setAppState);
  // setAppState({
  //   refreshingData: true,
  // });
  fetch(
    `${BaseURL}/api/getoptionschain?ticker=${ticker}&expiration=${expiration}&date=${date}`
  )
    .then((result) => checkStatusFunc(result, setAppState))
    .then((result) => parseJSONFunc(result))
    .then((response) => {
      if (!response || response.error) {
        setAppState({
          refreshingData: false,
          weekendErrors:
            "Unable to get data at this moment. The Date might be a weekend or holiday. Check symbol or try again later. If the problem still persists, email support@optionsgeek.com.",
        });
        return;
      } else {
        setAppState({
          data: response,
          refreshingData: false,
          weekendErrors: null,
        });
      }
    });
};

export const fetchSkewFunc = async (ticker, date, appState, setAppState) => {
  if (!ticker || ticker.length < 1) return;
  setAppState({
    refreshingData: true,
  });
  fetch(`${BaseURL}/api/getskew?ticker=${ticker}&date=${date}`)
    .then((result) => checkStatusFunc(result, setAppState))
    .then((result) => parseJSONFunc(result))
    .then((response) => {
      let newResponse = response
        .replace(/\\n/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\r/g, "\\r")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f");
      // // Remove non-printable and other non-valid JSON chars
      newResponse = newResponse.replace(/[\u0000-\u0019]+/g, "");

      if (!newResponse) return;
      // Save this to state below so can access in rest of application.
      let data = JSON.parse(newResponse).data;
      if (!data || !data[0]) return;
      const skew = data[0]["norm_d25_90_skew_pctl"];
      const imp_vol = data[0]["atm_ivol_pctl"];
      setAppState({
        skew,
        imp_vol,
        refreshingData: false,
      });
      // saveData(data);
    })
    .catch((error) => {
      const err = "Unknown Symbol";
      setAppState({
        errorMessages: [...appState.errorMessages, err],
        skew: null,
        imp_vol: null,
      });
    });
};

export const fetchExpirationsFunc = async (
  ticker,
  date,
  appState,
  setAppState
) => {
  if (!ticker || ticker.length < 1) return;
  await setAppState({
    refreshingData: true,
  });
  fetchCloseDataFunc(ticker, date, setAppState);
  fetch(`${BaseURL}/api/expirations?ticker=${ticker}&date=${date}`)
    .then((result) => {
      return checkStatusFunc(result, setAppState);
    })
    .then((result) => {
      return parseJSONFunc(result);
    })
    .then((response) => {
      const filterValidDates = response.filter((item) => item.expiry !== null) // Filter valid dates
      console.log({ filterValidDates, response })
      const err = "Unknown Symbol";
      if (response && response.length) {
        setAppState({
          sidepanelExpirations: filterValidDates,
        });
      } else {
        setAppState({
          weekendErrors:
            "Unable to get data at this moment. The Date might be a weekend or holiday. Check symbol or try again later. If the problem still persists, email support@optionsgeek.com.",
        });
        setAppState({
          sidepanelExpirations: [],
          errorMessages: [...appState.errorMessages, err],
        });
      }
    })
    .catch((error) => {
      const err = "Unknown Symbol";
      setAppState({
        weekendErrors:
          "Unable to get data at this moment. The Date might be a weekend or holiday. Check symbol or try again later. If the problem still persists, email support@optionsgeek.com.",
      });
      setAppState({
        sidepanelExpirations: [],

        errorMessages: [...appState.errorMessages, err],
      });
    });
};

export const checkStatusFunc = (response, setAppState) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(`HTTP Error: ${response.statusText}`);
  setAppState({
    weekendErrors:
      "Unable to get data at this moment. The Date might be a weekend or holiday. Check symbol or try again later. If the problem still persists, email support@optionsgeek.com.",
  });
  error.status = response.statusText;
  error.response = response;
};
export const parseJSONFunc = (response) => {
  if (response) return response.json();
};
export const fetchCloseDataFunc = (ticker, date, setAppState) => {
  fetch(
    `${BaseURL}/api/get-ticker-details/${ticker}?date=${date.replace(
      /-/g,
      ""
    )}`
  )
    .then((result) => checkStatusFunc(result, setAppState))
    .then((result) => parseJSONFunc(result))
    .then((response) => {
      if (!response || response.error) {
        setAppState({
          iexClose: "0",
        });
        return;
      }
      response.length > 0
        ? setAppState({
          iexClose: response[0]["close"],
        })
        : setAppState({ iexClose: "0" });

      /// this.props.setAppStateAction({ data: response, refreshingData: false });
    });
};

export const fetchNewsFunc = async (ticker, setAppState) => {
  var today = new Date();
  await firestore
    .collection("NEWS")
    .doc(ticker)
    .get()
    .then((doc) => {
      if (doc.exists) {
        var data = doc.data();
        var difference = today.getTime() - new Date(data["DATE"]).getTime();

        difference = difference / 1000 / 3600;
        if (difference < 3) {
          setAppState({
            articles: JSON.parse(data["NEWS"]),
          });
        } else {
          fetchNewNewsFunc(ticker, setAppState);
        }
      } else {
        fetchNewNewsFunc(ticker, setAppState);
      }
    });
};
export const fetchNewNewsFunc = async (ticker, setAppState) => {
  fetch(`${BaseURL}/api/newsByTicker?ticker=${ticker}`)
    .then((result) => checkStatusFunc(result, setAppState))
    .then((result) => parseJSONFunc(result))
    .then((response) => {
      if (response && response.data) {
        var data = {
          NEWS: JSON.stringify(response.data),
          DATE: new Date(),
        };
        firestore.collection("NEWS").doc(ticker).set(data);
        setAppState({ articles: response.data });
      }
    });
};

/**
 * @param {*} targetPrice
 * @param {*} appState
 * @param {*} setAppState
 */
export const targetPriceChangeFunc = (targetPrice, appState, setAppState) => {
  setAppState({ targetPrice });
  ReactGA.event({
    category: "ChainAction",
    action: "Changed target price",
    label: `${appState.ticker} by ${targetPrice}`,
  });
};

/**
 * @param {*} confidence
 * @param {*} appState
 * @param {*} setAppState
 */
export const confidenceChangeFunc = (confidence, appState, setAppState) => {
  setAppState({ confidence });
  // Sending confidence change to Google Analytics only once every 3 seconds
  if (appState.changeConfidenceDelay) return;
  setAppState({ changeConfidenceDelay: true });
  ReactGA.event({
    category: "ChainAction",
    action: "Changed confidence",
    label: `${confidence.toFixed(1)}`,
  });
  setTimeout(() => {
    setAppState({ changeConfidenceDelay: false });
  }, 3000); // Only send this action once every 3 seconds
};

export const jsonifyFunc = (json) => {
  if (json) {
    let newResponse = json
      .replace(/\\n/g, "\\n")
      .replace(/\\'/g, "\\'")
      .replace(/\\"/g, '\\"')
      .replace(/\\&/g, "\\&")
      .replace(/\\r/g, "\\r")
      .replace(/\\t/g, "\\t")
      .replace(/\\b/g, "\\b")
      .replace(/\\f/g, "\\f");
    // Remove non-printable and other non-valid JSON chars
    newResponse = newResponse.replace(/[\u0000-\u0019]+/g, "");
    newResponse = newResponse.replace(/:,/g, ":null,");
    if (!newResponse) return;
    // Save this to state below so can access in rest of application.
    let data = JSON.parse(newResponse).data;
    return data;
  }
};

export const returnCalendarExtraFunc = (
  row,
  sidepanelExpirations,
  calendarData
) => {
  var returner = "";
  var tips = "";
  const expirationDates = sidepanelExpirations.map((expiration) =>
    moment(expiration.expiry)
  );
  var extra = [];
  Object.keys(calendarData).map((key) => {
    extra.push(calendarData[key]);
  });
  extra.sort(function (a, b) {
    return new Date(b.date) - new Date(a.date);
  });
  const closests = extra.map((ext) => {
    const now = new Date(ext.date);
    let closest = Infinity;

    expirationDates.forEach(function (d) {
      const date = new Date(d);

      if (date >= now && (date < new Date(closest) || date < closest)) {
        closest = d;
      }
    });
    if (!moment(closest).isValid()) return;
    return closest.format("YYYY-MM-DD");
  });
  closests.forEach((close, index) => {
    if (extra && row && close === row.expiry) {
      if (extra[index].type === "Earnings") {
        returner = returner + "E";
        tips = tips + " Earnings : " + extra[index].date + "\n\r";
      }
      if (extra[index].type === "ExDiv") {
        returner = returner + "D";
        tips = tips + " Dividend : " + extra[index].date + "\n\r";
      }
      if (extra[index].comment.includes("est")) {
        returner = returner + "*";
        tips = tips + " " + extra[index].comment + "\n\r";
      }
    }
  });
  return [returner, tips];
};

export const handleUnload = () => {
  localStorage.setItem(
    "Date",
    moment().tz("America/New_York").format("YYYY-MM-DD")
  );
};

export const keyPressFunc = async (
  e,
  appState,
  setAppState,
  setOptionChainState,
  history
) => {
  const { accessLevel } = appState;
  if (e.keyCode === 13) {
    let date = momentz.tz(new Date(), "America/New_York").format("YYYY-MM-DD");
    const newDate = accessLevel === "fullaccess" ? is_weekend(date) : date;
    localStorage.setItem("Date", newDate);
    setOptionChainState({
      selectedDate: newDate,
      modalDate: newDate,
    });
    setOptionChainState({
      strikeValue: "all",
      nearValue: undefined,
    });
    localStorage.setItem("StrikeValue", "all");
    setOptionChainState({ localTicker: e.target.value });
    refreshDataAndExpirationsFunc(
      e.target.value,
      newDate,
      appState,
      setAppState
    );
    window.scroll(0, 0);
    history.push(`/optionschain/${e.target.value}`);
  }
};

// ----------------------------

const calcPremium = (bidAskMid, bid, ask) => {
  if (bidAskMid === "bid") return bid;
  if (bidAskMid === "ask") return ask;
  return (bid + ask) / 2;
};

const calcRR = (putVsCall, strike, premium, itm) => {
  if (itm === 0) return null;
  if (putVsCall === "C")
    return strike + premium / itm > 0 ? strike + premium / itm : null;
  if (putVsCall === "P")
    return strike - premium / itm > 0 ? strike - premium / itm : null;
};

const calcOMS = (putVsCall, RR, targetPrice) => {
  if (!targetPrice) return null;
  if (putVsCall === "C") return Math.max(targetPrice - RR, 0);
  if (putVsCall === "P") return Math.max(RR - targetPrice, 0);
};

const calcDollarGain = (putVsCall, targetPrice, premium, strike) => {
  if (!targetPrice) return null;
  if (putVsCall === "C") return targetPrice - premium - strike;
  if (putVsCall === "P") return Math.max(strike - targetPrice - premium, 0);
};

const calcExpGain = (targetPrice, dollarGain, itm) => {
  if (!targetPrice) return null;
  return dollarGain * itm;
};

const calcExpLoss = (targetPrice, premium, itm) => {
  if (!targetPrice) return null;
  return -premium * (1 - itm);
};

const calcEdge = (targetPrice, expGain, expLoss) => {
  if (!targetPrice) return null;
  return expGain + expLoss;
};

const calcEdgePercent = (targetPrice, premium, edge) => {
  if (!targetPrice) return null;
  return Math.max(edge / premium, 0);
};

const calcActualPercent = (targetPrice, dollarGain, premium) => {
  if (!targetPrice) return null;
  return Math.max(dollarGain / premium, 0);
};
export let noOMS = true;
export let callRows = [];
export let putRows = [];
export let finalArray = [];

export const makeReStructuredRows = (props) => {
  const { optionChainState, appState } = props;

  const { nearValue, strikeValue, bidAskMid } = optionChainState;
  const { targetPrice, confidence, quoteInfo, data } = appState;

  const { latestPrice } = quoteInfo;

  let highestCallEdge = { rowIndex: 0, value: 0 };
  let highestCallActual = { rowIndex: 0, value: 0 };
  let highestPutEdge = { rowIndex: 0, value: 0 };
  let highestPutActual = { rowIndex: 0, value: 0 };
  const answerArrowPos = confidence / 10;
  let currentPriceArrowPos = { rowPos: undefined, value: undefined }; //Value set to 10000 as starting point.
  // Sort into call or put row and do all of the calculations.

  callRows = [];
  putRows = [];
  if (data.length) {
    if (strikeValue === "all") {
      finalArray = [...data];
    } else {
      let closest = data[0].strike;

      if (
        nearValue < data[0].strike ||
        nearValue > data[data.length - 1].strike
      ) {
        closest = data[0].strike;
      } else {
        for (let item of data) {
          if (
            Math.abs(item.strike - nearValue) < Math.abs(closest - nearValue)
          ) {
            closest = item.strike;
          }
        }
      }

      if (nearValue) {
        let indextoFind;
        indextoFind = data.findIndex((x) => x.strike === closest);
        const dividedStrike = Number(strikeValue);
        const beforeLength = data.slice(0, indextoFind).length;
        const afterLength = data.slice(indextoFind + 1, data.length).length;
        let beforeStart;
        let afterEnd;
        beforeStart =
          beforeLength >= dividedStrike
            ? indextoFind - dividedStrike
            : indextoFind - beforeLength;
        afterEnd =
          afterLength >= dividedStrike
            ? indextoFind + dividedStrike + 1
            : indextoFind + afterLength;
        let beforeTenArray =
          beforeStart === 0
            ? data.slice(0, indextoFind)
            : data.slice(beforeStart + 2, indextoFind);
        const nextTenArray = data.slice(indextoFind, afterEnd + 1);
        finalArray = beforeTenArray.concat(nextTenArray);
      }
    }
  }

  finalArray.map((item) => {
    let updatedItem = item;
    const strike = item.strike;
    const itm = item.itm_prob; // ITM returning 0 if it's a 100% itm.
    updatedItem.itm = itm;

    const premium = calcPremium(bidAskMid, item.theo_bid, item.theo_ask);
    updatedItem.premium = premium;

    const RR = calcRR(item.put_call, strike, premium, itm);
    updatedItem.RR = RR;
    const OMS = calcOMS(item.put_call, RR, targetPrice);
    updatedItem.OMS = OMS;

    // These calculations aren't actually displayed, so don't need to add to updatedItem
    const dollarGain = calcDollarGain(
      item.put_call,
      targetPrice,
      premium,
      strike
    );

    const expGain = calcExpGain(targetPrice, dollarGain, itm);
    const expLoss = calcExpLoss(targetPrice, premium, itm);
    const edge = calcEdge(targetPrice, expGain, expLoss);
    const edgePercent = calcEdgePercent(targetPrice, premium, edge);
    updatedItem.edgePercent = edgePercent;
    const actualPercent = calcActualPercent(targetPrice, dollarGain, premium);
    updatedItem.actualPercent = actualPercent;
    if (item.put_call === "C") return callRows.push(updatedItem);
    return putRows.push(updatedItem);
  });
  // Sort so that ordered by strike from smallest to largest
  callRows = callRows.sort((a, b) => {
    return a.strike - b.strike;
  });

  // Sort so that ordered by strike from smallest to largest
  putRows = putRows.sort((a, b) => {
    return a.strike - b.strike;
  });

  let noOMS = true;

  callRows.map((item, index) => {
    if (
      item.edgePercent > highestCallEdge.value &&
      item.edgePercent !== Infinity
    ) {
      highestCallEdge.value = item.edgePercent;
      highestCallEdge.rowIndex = index;
    }

    if (
      item.actualPercent > highestCallActual.value &&
      item.actualPercent !== Infinity
    ) {
      highestCallActual.value = item.actualPercent;
      highestCallActual.rowIndex = index;
    }

    // Used for OMS warning
    if (item.OMS > 0 && item.itm_prob >= 0.245 && item.itm_prob <= 0.4459)
      noOMS = false;
    let closest = callRows[0].strike;
    for (let item of callRows) {
      if (
        Math.abs(item.strike - latestPrice) <= Math.abs(closest - latestPrice)
      ) {
        closest = item.strike;
        const indextoFind = callRows.findIndex((x) => x.strike === closest);
        currentPriceArrowPos.rowPos = indextoFind;
        currentPriceArrowPos.value = callRows[indextoFind].strike;

        if (callRows[0].strike > Math.round(latestPrice)) {
          currentPriceArrowPos.value = undefined;
        }
        // if (parseInt(currentPriceArrowPos.value) > Math.round(latestPrice)) {
        //   currentPriceArrowPos.value = undefined
        // }
      }
    }
  });
  putRows.map((item, index) => {
    if (
      item.edgePercent > highestPutEdge.value &&
      item.edgePercent !== Infinity
    ) {
      highestPutEdge.value = item.edgePercent;
      highestPutEdge.rowIndex = index;
    }

    if (
      item.actualPercent > highestPutActual.value &&
      item.actualPercent !== Infinity
    ) {
      highestPutActual.value = item.actualPercent;
      highestPutActual.rowIndex = index;
    }

    // For warning calc
    if (item.OMS > 0 && item.itm_prob >= 0.25 && item.itm_prob <= 0.4459)
      noOMS = false;
  });
  //Calc ArrowPos
  let callsAnswerArrowPos = confidence / 10;

  if (callRows.length > 0) {
    let callsAnswerValOffset =
      callRows[highestCallActual.rowIndex]["strike"] -
      callRows[highestCallEdge.rowIndex]["strike"];
    let callsAnswerVal =
      callRows[highestCallEdge.rowIndex]["strike"] +
      callsAnswerValOffset * answerArrowPos;
    let callIndex = highestCallActual.rowIndex;
    if (callsAnswerValOffset >= 0) {
      for (
        var i = highestCallEdge.rowIndex;
        i < highestCallActual.rowIndex;
        i++
      ) {
        if (callRows[i]["strike"] > callsAnswerVal) {
          callIndex = i;
          break;
        }
      }
      var offset = 1;
      if (callIndex > 0) {
        var offset =
          (callsAnswerVal - callRows[callIndex - 1]["strike"]) /
          (callRows[callIndex]["strike"] - callRows[callIndex - 1]["strike"]);
        callIndex = callIndex - 1 + offset - highestCallEdge.rowIndex;
        callsAnswerArrowPos = Math.abs(
          callIndex / (highestCallActual.rowIndex - highestCallEdge.rowIndex)
        );
      }
    } else {
      for (
        var i = highestCallActual.rowIndex;
        i < highestCallEdge.rowIndex;
        i++
      ) {
        if (callRows[i]["strike"] > callsAnswerVal) {
          callIndex = i;
          break;
        }
      }
      var offset = 1;
      if (callIndex > 0) {
        var offset =
          (callRows[callIndex]["strike"] - callsAnswerVal) /
          (callRows[callIndex]["strike"] - callRows[callIndex - 1]["strike"]);
        callsAnswerArrowPos = Math.abs(
          (callIndex - offset - highestCallEdge.rowIndex) /
          (highestCallActual.rowIndex - highestCallEdge.rowIndex)
        );
      }
    }
  }
  let putsAnswerArrowPos = confidence / 10;

  if (putRows.length > 0) {
    let putAnswerValOffset =
      putRows[highestPutActual.rowIndex]["strike"] -
      putRows[highestPutEdge.rowIndex]["strike"];
    let putsAnswerVal =
      putRows[highestPutEdge.rowIndex]["strike"] +
      putAnswerValOffset * answerArrowPos;
    let putIndex = highestPutActual.rowIndex;
    if (putAnswerValOffset >= 0) {
      for (
        var i = highestPutEdge.rowIndex;
        i < highestPutActual.rowIndex;
        i++
      ) {
        if (putRows[i]["strike"] > putsAnswerVal) {
          putIndex = i;
          break;
        }
      }
      var offset = 1;
      if (putIndex > 0) {
        var offset =
          (putsAnswerVal - putRows[putIndex - 1]["strike"]) /
          (putRows[putIndex]["strike"] - putRows[putIndex - 1]["strike"]);
        putIndex = putIndex - 1 + offset - highestPutEdge.rowIndex;
        putsAnswerArrowPos = Math.abs(
          putIndex / (highestPutActual.rowIndex - highestPutEdge.rowIndex)
        );
      }
    } else {
      for (
        var i = highestPutActual.rowIndex;
        i < highestPutEdge.rowIndex;
        i++
      ) {
        if (putRows[i]["strike"] > putsAnswerVal) {
          putIndex = i;
          break;
        }
      }
      var offset = 1;
      if (putIndex > 0) {
        var offset =
          (putsAnswerVal - putRows[putIndex - 1]["strike"]) /
          (putRows[putIndex]["strike"] - putRows[putIndex - 1]["strike"]);
        putIndex = putIndex - 1 + offset - highestPutEdge.rowIndex;
        putsAnswerArrowPos = Math.abs(
          putIndex / (highestPutActual.rowIndex - highestPutEdge.rowIndex)
        );
      }
    }
  }

  return {
    callRows,
    putRows,
    highestCallEdge,
    highestCallActual,
    highestPutEdge,
    highestPutActual,
    answerArrowPos,
    callsAnswerArrowPos,
    noOMS,
    putsAnswerArrowPos,
    currentPriceArrowPos,
  };
};

export const arrivedViaQueryFunc = (query, date, appState, setAppState) => {
  const { ticker, confidence, expiration, targetprice } = query;
  if (!ticker) return;
  const toSetConfidence = confidence ? confidence / 10 : 8;
  const toSetExpiration = expiration ? expiration : "";
  const toSetTargetPrice = targetprice ? targetprice : "";
  setAppState({
    ticker,
    confidence: toSetConfidence,
    tickerChanged: true,
    expiration: toSetExpiration,
    dontChangeExpiration: true,
    targetPrice: toSetTargetPrice,
  });
  fetchQuoteInfoFunc(ticker, date, appState, setAppState);
  getExpirationOptionsFunc(ticker, date, appState, setAppState);
  ReactGA.event({
    category: "User",
    action: "Arrived at Opt Chain via Share Link",
    label: `T: ${ticker}, E: ${toSetExpiration}, C: ${toSetConfidence}, TP: ${toSetTargetPrice}`,
  });
};

export const fetchOpenInterestFunc = (ticker, appState, setAppState) => {
  let date = momentz.tz(new Date(), "America/New_York").format("YYYY-MM-DD");
  const newDate =
    appState.accessLevel === "fullaccess" ? is_weekend(date) : date;

  fetchHolderListFunc(ticker, setAppState);
  fetchQuoteInfoFunc(ticker, date, appState, setAppState);
  fetchNewsFunc(ticker, setAppState);
  var docRef = firestore.collection("openinterest").doc(ticker);
  docRef.get().then((doc) => {
    if (doc.exists) {
      const opData = doc.data();
      var data = JSON.parse(opData["data"]);
      var dates = [];
      var strikes = [];
      var nowDate = new Date();

      for (var i = 0; i < data.length; i++) {
        var dataDate = new Date(data[i]["expiry"]);
        var availableDate = true;
        if (
          data[i]["expiry"] !== "" &&
          data[i]["expiry"] !== undefined &&
          availableDate
        )
          dates.push(data[i]["expiry"]);
        if (data[i]["strike"] !== "" && data[i]["strike"] !== undefined)
          strikes.push(data[i]["strike"]);
      }
      strikes = [...new Set(strikes)];
      dates = [...new Set(dates)];
      dates.sort();
      strikes.sort(function (a, b) {
        return a - b;
      });
      dates.unshift("Strike");
      var OIDataCall = [];
      var OIDataPut = [];

      var callMax = 0;
      var putMax = 0;
      for (var i = 0; i < data.length; i++) {
        var strikeIndex = strikes.indexOf(data[i]["strike"]);
        var dateIndex = dates.indexOf(data[i]["expiry"]);
        if (!OIDataCall[strikeIndex]) {
          OIDataCall[strikeIndex] = Array(dates.length).fill(0);
          OIDataCall[strikeIndex][0] = data[i]["strike"];
        }
        if (!OIDataPut[strikeIndex]) {
          OIDataPut[strikeIndex] = Array(dates.length).fill(0);
          OIDataPut[strikeIndex][0] = data[i]["strike"];
        }
        if (data[i]["put_call"] === "C") {
          OIDataCall[strikeIndex][dateIndex] =
            data[i]["open_int"] === undefined || data[i]["open_int"] === ""
              ? 0
              : data[i]["open_int"];
          if (callMax < data[i]["open_int"]) callMax = data[i]["open_int"];
        } else {
          OIDataPut[strikeIndex][dateIndex] =
            data[i]["open_int"] === undefined || data[i]["open_int"] === ""
              ? 0
              : data[i]["open_int"];
          if (putMax < data[i]["open_int"]) putMax = data[i]["open_int"];
        }
      }

      setAppState({
        OIDataCall,
        OIDataPut,
        dates,
        OIDates: dates,
        OIStrikes: strikes,
        OICallMax: callMax,
        OIPutMax: putMax,
      });
    }
  });
};



// WEBPACK FOOTER //
// ./src/Shared/index.js